import { Directive } from '@angular/core';
import { RouterLink } from '@angular/router';

@Directive({
  selector: 'a[routerLink][appOpenInNewTab]',
  standalone: false,
  host: {
    '[attr.target]': 'target',
    '[attr.rel]': 'rel',
  },
})
export class OpenRouterLinkInNewTab {
  readonly target = '_blank';
  readonly rel = 'noopener noreferrer';

  constructor(routerLink: RouterLink) {
    // RouterLink checks its own target property before deciding whether to
    // intercept the click, so set both it and the native host attribute.
    routerLink.target = this.target;
  }
}
